import React, { useState } from "react";
import Style from "./ChoosePanel.module.css";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { logOutApi } from "../../Api/DeliveryBarest";
import { errorToast } from "../../Utils/Toast/Toast";
const ChoosePanel = () => {
  const history = useHistory();
  const [disable, setDisable] = useState(false);
  const logout = () => {
    setDisable(true);
    let info = {
      logout: "",
    };
    logOutApi(info, (succ) => {
      if (succ.status === 1) {
        setDisable(false);
        localStorage.clear();
        errorToast("خارج شدین");
        window.location.reload();
      } else {
        setDisable(false);
        errorToast(succ.message);
      }
    });
  };
  return (
    <section className={Style.pageHolder}>
      <h3>سلام همکار عزیز! !</h3>
      <h3>برای شروع لطفا یک پنل را انتخاب کنید.</h3>
      <div
        className={Style.CardHolder}
        onClick={() => history.push("./deliverypanel")}
      >
        <img src="./Assets/Images/profile/delivery.svg" alt="" />
        <p>پیک</p>
      </div>
      <div className={Style.CardHolder}>
        <img
          src="./Assets/Images/profile/taxi.svg"
          alt=""
          onClick={() => history.push("./taxireq")}
        />
        <p>تاکسی</p>
      </div>
      <button className={Style.signOutBtn} disabled={disable} onClick={logout}>
        {disable ? (
          "منتظر باشید..."
        ) : (
          <>
            <FontAwesomeIcon icon={faSignOutAlt} />
            خروج
          </>
        )}
      </button>
    </section>
  );
};

export default ChoosePanel;
